module.exports = __webpack_public_path__ + "img/2.92fb17ec.jpg";